import { NgModule } from '@angular/core';

import  {SharedModule } from "../../shared/shared.module";
import { LocalidadesComponent } from './localidades.component';
import { LocalidadesRoutingModule } from "./localidades-routing.module";
import { LocalidadeListComponent } from './localidade-list/localidade-list.component';
import { LocalidadeApiService } from "./shared/localidade-api.service";
import { LocalidadeNavigationService } from "./shared/localidade-navigation.service";
import { LocalidadeService } from "./shared/localidade.service";
import { LocalidadeFormComponent } from "./localidade-form/localidade-form.component";
import { EnderecosModule } from "../enderecos/enderecos.module";
import { LocalidadeTiposModule } from "./localidades-tipos/localidade-tipos.module";

@NgModule({
  imports: [
    SharedModule,
    EnderecosModule,
    LocalidadeTiposModule,
    LocalidadesRoutingModule
  ],
  providers:[
    LocalidadeApiService,
    LocalidadeNavigationService,
    LocalidadeService
  ],
  declarations: [
    LocalidadesComponent,
    LocalidadeListComponent,
    LocalidadeFormComponent
  ]
})
export class LocalidadesModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/localidades/localidades.module.ts
 **/